// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --page-margin: var(--app-fair-margin);
  --page-background: var(--app-background-alt-shade);
  --page-headers-shadow-color: rgba(var(--ion-color-darkest-rgb), 0.4);
}

.app-side-menu {
  border-right: 0.5px solid black !important;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
.app-side-menu ion-toolbar {
  --padding-start: 0px;
  --padding-end: 0px;
  --padding-top: 0px;
  --padding-bottom: 0px;
}
.app-side-menu ion-content {
  --background: var(--page-background);
}
.app-side-menu .user-details-wrapper {
  --ion-grid-column-padding: 0px;
  margin-right: 10px;
  color: var(--ion-color-lightest);
  padding: var(--page-margin);
  align-items: center;
}
.app-side-menu .user-details-wrapper + .user-details-wrapper {
  padding-top: 0px;
}
.app-side-menu .user-info-wrapper .user-name {
  margin: 0px 0px 5px;
  color: black;
}
.app-side-menu .user-info-wrapper .user-handle {
  color: var(--ion-color-light-shade);
  margin: 0px;
  font-size: 14px;
  font-weight: 400;
}
.app-side-menu .user-stats-wrapper {
  text-align: center;
}
.app-side-menu .user-stats-wrapper .user-stat-value {
  color: var(--ion-color-light-shade);
  margin-right: 5px;
  font-weight: 500;
}
.app-side-menu .user-stats-wrapper .user-stat-name {
  color: var(--ion-color-light-shade);
  font-size: 14px;
}
.app-side-menu ion-list {
  --ion-text-color: var(--ion-color-light-shade);
  --ion-text-color-rgb: var(--ion-color-light-shade-rgb);
  --ion-item-background: #363636;
  --ion-item-border-color: transparent;
}
.app-side-menu ion-list ion-list-header {
  text-transform: uppercase;
  padding-inline-start: var(--page-margin);
  font-size: 1.2em;
  font-weight: 900;
  margin-bottom: 8px;
}
.app-side-menu ion-list ion-item {
  --border-width: 0px !important;
  --padding-start: var(--page-margin);
  --background-activated: var(--ion-color-medium);
}
.app-side-menu ion-list ion-icon {
  color: var(--ion-color-light-shade);
}`, "",{"version":3,"sources":["webpack://./src/app/style/side-menu.scss"],"names":[],"mappings":"AAEA;EACE,qCAAA;EACA,kDAAA;EAEA,oEAAA;AAFF;;AAMA;EACE,0CAAA;EACA,wCAAA;EACA,6BAAA;EACA,gCAAA;AAHF;AAIE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAFJ;AAME;EACE,oCAAA;AAJJ;AAOE;EACE,8BAAA;EACA,kBAAA;EAGA,gCAAA;EACA,2BAAA;EACA,mBAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAcI;EACE,mBAAA;EACA,YAAA;AAZN;AAeI;EACE,mCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAbN;AAiBE;EACE,kBAAA;AAfJ;AAiBI;EACE,mCAAA;EACA,iBAAA;EACA,gBAAA;AAfN;AAkBI;EACE,mCAAA;EACA,eAAA;AAhBN;AAqBE;EACE,8CAAA;EACA,sDAAA;EACA,8BAAA;EACA,oCAAA;AAnBJ;AAqBI;EAEE,yBAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AApBN;AAuBI;EACE,8BAAA;EACA,mCAAA;EACA,+CAAA;AArBN;AAwBI;EACE,mCAAA;AAtBN","sourcesContent":["// Custom variables\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\n:host {\n  --page-margin: var(--app-fair-margin);\n  --page-background: var(--app-background-alt-shade);\n\n  --page-headers-shadow-color: rgba(var(--ion-color-darkest-rgb), 0.4);\n}\n\n// Note:  All the CSS variables defined below are overrides of Ionic elements CSS Custom Properties\n.app-side-menu {\n  border-right: 0.5px solid black !important;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n  ion-toolbar {\n    --padding-start: 0px;\n    --padding-end: 0px;\n    --padding-top: 0px;\n    --padding-bottom: 0px;\n    // --background: var(--ion-color-dark-tint);\n  }\n\n  ion-content {\n    --background: var(--page-background);\n  }\n\n  .user-details-wrapper {\n    --ion-grid-column-padding: 0px;\n    margin-right: 10px;\n\n    // background-color: rgba(var(--ion-color-light-rgb), 0.15);\n    color: var(--ion-color-lightest);\n    padding: var(--page-margin);\n    align-items: center;\n\n    & + .user-details-wrapper {\n      padding-top: 0px;\n    }\n  }\n\n  .user-info-wrapper {\n    // padding-left: var(--page-margin);\n\n    .user-name {\n      margin: 0px 0px 5px;\n      color: black;\n    }\n\n    .user-handle {\n      color: var(--ion-color-light-shade);\n      margin: 0px;\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n\n  .user-stats-wrapper {\n    text-align: center;\n\n    .user-stat-value {\n      color: var(--ion-color-light-shade);\n      margin-right: 5px;\n      font-weight: 500;\n    }\n\n    .user-stat-name {\n      color: var(--ion-color-light-shade);\n      font-size: 14px;\n    }\n  }\n\n  // Menu list items\n  ion-list {\n    --ion-text-color: var(--ion-color-light-shade);\n    --ion-text-color-rgb: var(--ion-color-light-shade-rgb);\n    --ion-item-background: #363636;\n    --ion-item-border-color: transparent;\n\n    ion-list-header {\n      // --color: rgba(var(--ion-color-light-shade-rgb), 0.6);\n      text-transform: uppercase;\n      padding-inline-start: var(--page-margin);\n      font-size: 1.2em;\n      font-weight: 900;\n      margin-bottom: 8px;\n    }\n\n    ion-item {\n      --border-width: 0px !important;\n      --padding-start: var(--page-margin);\n      --background-activated: var(--ion-color-medium);\n    }\n\n    ion-icon {\n      color: var(--ion-color-light-shade);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
